import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Table, TableRow, TableBody, Checkbox } from '@mui/material';
import { BoldTableHead, BoxActionsWrapper, DenseTableCell } from 'components/common/CommonStyles';
import { Button, Dialog } from '@totalsoft/rocket-ui';

const OfferFoldersListComponent = ({ folderList, t, onRowSelectionChanged, showModal, onSaveFolder, closeFoldersModal }) => {
  const onCheckboxChanged = folder => event => {
    onRowSelectionChanged(folder.folderId, event.target.checked);
  };

  return (
    <Dialog
      open={showModal}
      aria-labelledby='reports-dialog-title'
      maxWidth='sm'
      fullWidth
      disableBackdropClick
      disableEscapeKeyDown
      onClose={closeFoldersModal}
      title={t('OfferAction.Folders')}
      content={
        <Grid container>
          <Grid item xs={12}>
            <Table>
              <BoldTableHead>
                <TableRow>
                  <DenseTableCell>{t('Offer.FolderNumber')}</DenseTableCell>
                  <DenseTableCell></DenseTableCell>
                </TableRow>
              </BoldTableHead>
              <TableBody>
                {folderList?.map(folder => {
                  return (
                    <TableRow key={folder.folderId}>
                      <DenseTableCell>{folder.folderNumber || t('Offer.NewFolder')}</DenseTableCell>
                      <DenseTableCell align='right'>
                        <Checkbox name={'selected'} checked={folder.selected || false} onChange={onCheckboxChanged(folder)} value='1' />
                      </DenseTableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      }
      actions={
        <BoxActionsWrapper forDialog>
          <Button onClick={onSaveFolder}>{t('Save')}</Button>
          <Button onClick={closeFoldersModal} variant='outlined'>
            {t('Close')}
          </Button>
        </BoxActionsWrapper>
      }
    />
  );
};

OfferFoldersListComponent.propTypes = {
  t: PropTypes.func.isRequired,
  onRowSelectionChanged: PropTypes.func.isRequired,
  folderList: PropTypes.array.isRequired,
  closeFoldersModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  onSaveFolder: PropTypes.func.isRequired
};

export default withTranslation()(OfferFoldersListComponent);
